module.exports = __webpack_public_path__ + "img/29625334000132.03f4c13f.png";